<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/monitor")
            i.fa.fa-eye
            span.ml-1 {{ $t("ui.monitor") }}
        b-breadcrumb-item
          router-link(to="/monitor/omcache")
            i.fa.fa-microchip
            span.ml-1 {{ $t("ui.omcache") }}
        b-breadcrumb-item(v-if="filterKeyBy")
          span {{ filterKeyBy }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row(v-if="cacheTblShow")
              div.col-md-3
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    i.fa.fa-link
                  b-input(:value="displayProvider" readonly).text-uppercase
                  b-input(:value="displaySportType" readonly).text-uppercase
                  b-input(:value="displayMarketType" readonly).text-uppercase
                  b-input(:value="displayBetType" readonly).text-uppercase
              //- div.col-md-2
                //- b-input-group(size="sm").mb-1
                //-   b-input-group-text(slot="prepend")
                //-     i.fa.fa-gamepad
                //-   b-input(:value="sportType + ', ' + marketType + ', ' + betType" readonly).text-uppercase
              div.col-md-3
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    i.fa.fa-robot
                  b-input(:value="bot" readonly)
                  b-input(:value="loginId" readonly)
              div.col-md-1
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    i.fa.fa-cog
                  b-input(:value="status" readonly).text-uppercase
              div.col-md-2
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    i.fa.fa-stamp
                  b-input(:value="$moment(new Date(epochTime / 1000000)).format('YYYY-MM-DD hh:mm:ss.SSS A')" readonly)
              div.col-md-2
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    div.d-flex.justify-content-center.align-items-center
                      label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                        input.switch-input(type="checkbox" v-model="$options.refreshEnabled" @change="toggleRefresh()")
                        span.switch-slider(:data-checked='on' :data-unchecked='off')
                  b-input(v-model="refreshTime" type="range" min="1" max="5")
                  b-input-group-text(slot="append")
                    div(style="text-transform: none;") {{ refreshTime }} s
              div.col-md-1
                b-input-group(size="sm").mb-1
                  b-input-group-text(slot="prepend")
                    i.fa.fa-clock
                  b-input(:value="$moment(refreshUpdate).format('hh:mm:ss')" readonly)
            div.row(v-if="!cacheTblShow" style="width: 30%;").mb-1
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $tc('ui.sports', 1) }}
                b-form-select(v-model="sportType")
                  option(v-for="sportInfo in sportOption" v-bind:value="sportInfo.value")
                    | {{ sportInfo.text }}
              //- b-form-radio-group(v-model="sportType" :options="sportOption" buttons button-variant="outline-primary" size="sm" name="radio-btn-outline")
            div.row(v-if="!cacheTblShow" style="width: 30%;").mb-1
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $t('ui.market') }}
                b-form-select(v-model="marketType")
                  option(v-for="marketInfo in marketOption" v-bind:value="marketInfo.value")
                    | {{ marketInfo.text }}
              //- b-form-radio-group(v-model="marketType" :options="marketOption" buttons button-variant="outline-secondary" size="sm" name="radio-btn-outline")
            div.row(v-if="!cacheTblShow" style="width: 30%;").mb-1
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $t('ui.type') }}
                b-form-select(v-model="betType")
                  option(v-for="betInfo in betOption" v-bind:value="betInfo.value")
                    | {{ betInfo.text }}
            div.row(v-if="!cacheTblShow" style="width: 30%;").mb-1
              b-input-group(size="sm")
                b-input-group-text(slot="prepend")
                  span {{ $tc('ui.providers', 1) }}
                b-form-select(v-model="providerType")
                  option(v-for="providerInfo in providerOption" v-bind:value="providerInfo.value")
                    | {{ providerInfo.text }}
                //- b-form-select(v-model="providerType")
                //-   option(value="") {{ $t("ui.all") }}
                //-   option(value="sbo") {{ $t("ui.sbo") }}
                //-   option(value="ibc") {{ $t("ui.ibc") }}
              //- b-form-radio-group(v-model="betType" :options="betOption" buttons button-variant="outline-info" size="sm" name="radio-btn-outline")
          div.card-body.p-1
            div(v-if="!cacheTblShow")
              div.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="icon-reload"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getOMCacheKeyList()"
                  variant="info"
                  size="sm"
                  ).mb-1
              .clusterize
                #scrollArea.clusterize-scroll
                  table.tablex(style="width: auto;").mb-5
                    thead
                      tr
                        th.sticky-position(@click="sortOrder('provider')")
                          span {{ $tc("ui.providers", 1) }}
                          i(:class="changeSortKey('provider')")
                        th.sticky-position(@click="sortOrder('market_type')")
                          span {{ $t("ui.market") }}
                          i(:class="changeSortKey('market_type')")
                        th.sticky-position(@click="sortOrder('sport_type')")
                          span {{ $tc("ui.sports", 1) }}
                          i(:class="changeSortKey('sport_type')")
                        th.sticky-position(@click="sortOrder('bet_type')")
                          span {{ $t("ui.bet_type") }}
                          i(:class="changeSortKey('bet_type')")
                        //- th.sticky-position
                        //-   span {{ $tc("ui.bots", 1) }}
                        th.sticky-position
                          span {{ $t("ui.action") }}
                    tbody.clusterize-content
                      tr(v-for="(item, index) in filterKeyList")
                        td
                          span.text-uppercase {{ item.provider }}
                        td
                          span.text-uppercase {{ item.market_type }}
                        td
                          span.text-uppercase {{ item.sport_type }}
                        td
                          span.text-uppercase {{ item.bet_type }}
                        //- td
                        //-   span.text-uppercase {{ item.bot }}
                        td.actions
                          a.fa.fa-search.text-primary(href="#" @click="showCache(item.key)" :title="$t('ui.show')" v-if="!loading")
            div(v-if="cacheTblShow")
              div.mb-1
                SubmitButton(
                  :loading="loading"
                  icon="icon-arrow-left"
                  :text="$t('ui.back')"
                  type="button"
                  @click="hideCache()"
                  variant="secondary"
                  size="sm"
                  ).mb-1.mr-1
                SubmitButton(
                  :loading="loading"
                  icon="icon-reload"
                  :text="$t('ui.refresh')"
                  type="button"
                  @click="getOMCacheList()"
                  variant="info"
                  size="sm"
                  ).mb-1
              div(v-if="displayBetType == 'oetg' && displayProvider.toLowerCase() == 'cmd'")
                CMDOETGCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'main' && displayProvider.toLowerCase() == 'cmd' && displaySportType.toLowerCase() == 'esports'")
                CMDEsportsMainCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'oetg' && displayProvider.toLowerCase() == 'sbo'")
                SBOOETGCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'fglg' && displayProvider.toLowerCase() == 'ibc'")
                FLGCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'fcs' || displayBetType == 'hcs'")
                CSCacheTable(
                  :cacheList="cacheList"
                  :betType="displayBetType"
                )
              div(v-else-if="displayBetType == 'special' && displaySportType.toLowerCase() == 'football'")
                SPECIALCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'main' || displayBetType == 'special' || displayBetType == 'fulltime' || displayBetType == 'halftime'")
                MAINCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'more'")
                MORECacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'outright'")
                ORCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'fglg'")
                FGLGCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'htft'")
                HTFTCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == '1x2dc'")
                OneXTwoDCCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'hfoe'")
                HFOECacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'mo1x2'")
                MO1X2CacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'oe'")
                OECacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'tg'")
                TGCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'ml'")
                SBOMLCacheTable(
                  :cacheList="cacheList"
                )
              div(v-else-if="displayBetType == 'half'")
                SBOHALFCacheTable(
                  :cacheList="cacheList"
                )
</template>
<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import SparkMD5 from "spark-md5";
import _ from "lodash";
//General cache Table
import MAINCacheTable from "@/library/cache/MAINCacheTable";
import MORECacheTable from "@/library/cache/MORECacheTable";
import CSCacheTable from "@/library/cache/CSCacheTable";
import FGLGCacheTable from "@/library/cache/FGLGCacheTable";
import ORCacheTable from "@/library/cache/ORCacheTable";
import HTFTCacheTable from "@/library/cache/HTFTCacheTable";
import OneXTwoDCCacheTable from "@/library/cache/1X2DCCacheTable";
//CMD cache Table
import CMDOETGCacheTable from "@/library/cache/CMD/OETGCacheTable";
import CMDEsportsMainCacheTable from "@/library/cache/CMD/EsportsMainCacheTable";
//IBC cache Table
import FLGCacheTable from "@/library/cache/IBC/FLGCacheTable";
import HFOECacheTable from "@/library/cache/IBC/HFOECacheTable";
import MO1X2CacheTable from "@/library/cache/IBC/MO1X2CacheTable";
import OECacheTable from "@/library/cache/IBC/OECacheTable";
import TGCacheTable from "@/library/cache/IBC/TGCacheTable";
import SPECIALCacheTable from "@/library/cache/IBC/SPECIALCacheTable";
//SBO cache Table
import SBOOETGCacheTable from "@/library/cache/SBO/OETGCacheTable";
import SBOMLCacheTable from "@/library/cache/SBO/MLCacheTable";
import SBOHALFCacheTable from "@/library/cache/SBO/HALFCacheTable";

import { templateElement } from "babel-types";

export default {
  components: {
    SubmitButton,
    MAINCacheTable,
    MORECacheTable,
    CSCacheTable,
    FGLGCacheTable,
    ORCacheTable,
    HTFTCacheTable,
    OneXTwoDCCacheTable,
    CMDOETGCacheTable,
    CMDEsportsMainCacheTable,
    FLGCacheTable,
    HFOECacheTable,
    MO1X2CacheTable,
    OECacheTable,
    TGCacheTable,
    SBOOETGCacheTable,
    SPECIALCacheTable,
    SBOMLCacheTable,
    SBOHALFCacheTable
  },
  data() {
    return {
      cacheTblShow: false,
      loading: false,
      keyOption: [],
      keyList: [],
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      filterKeyBy: "",
      bot: "",
      epochTime: "",
      loginId: "",
      md5: "",
      lastUpdate: "",
      status: "",
      provider: "",
      marketType: "",
      sportType: "",
      betType: "",
      tempProvider: "",
      tempMarketType: "",
      tempSportType: "",
      tempBetType: "",
      onContentReady: function(e) {
        if (!collapsed) {
          e.component.expandRow(e.component.getKeyByRowIndex(0));
          collapsed = true;
        }
      },
      timerId: null,
      refreshTime: 5,
      refreshUpdate: "",
      cacheList: [],
      cacheHash: [],
      providerType: "",
      sortKey: "provider",
      sortType: "asc",
      displayProvider: "",
      displayMarketType: "",
      displaySportType: "",
      displayBetType: ""
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    sportOption: function() {
      // var tempList = _.mapValues(_.groupBy(this.keyList, "sport_type"), clist => clist.map(list => _.omit(list, "sport_type")));
      var tempList = this.keyList.reduce((r, v, i, a, k = v.sport_type) => ((r[k] || (r[k] = [])).push(v), r), {});
      var list = [];

      list.push({
        text: "ALL SPORTS (" + this.keyList.length + ")",
        value: ""
      });

      for (var prop in tempList) {
        list.push({
          text: prop + " (" + tempList[prop].length + ")",
          value: prop,
          disabled: tempList[prop].length > 0 ? false : true
        });
      }

      return list.sort((a, b) => {
          return a["text"] > b["text"] ? 1 : -1;
      });
    },
    marketOption: function() {
      var tempList = this.keyList.reduce((r, v, i, a, k = v.market_type) => ((r[k] || (r[k] = [])).push(v), r), {});
      var list = [];

      list.push({
        text: "ALL MARKETS (" + this.keyList.length + ")",
        value: ""
      });

      for (var prop in tempList) {
        list.push({
          text: prop + " (" + tempList[prop].length + ")",
          value: prop,
          disabled: tempList[prop].length > 0 ? false : true
        });
      }

      return list;
    },
    betOption: function() {
      var tempList = this.keyList.reduce((r, v, i, a, k = v.bet_type) => ((r[k] || (r[k] = [])).push(v), r), {});
      var list = [];

      list.push({
        text: "ALL TYPES (" + this.keyList.length + ")",
        value: ""
      });

      for (var prop in tempList) {
        list.push({
          text: prop + " (" + tempList[prop].length + ")",
          value: prop,
          disabled: tempList[prop].length > 0 ? false : true
        });
      }

      return list;
    },
    providerOption: function() {
      var tempList = this.keyList.reduce((r, v, i, a, k = v.provider) => ((r[k] || (r[k] = [])).push(v), r), {});
      var list = [];

      list.push({
        text: "ALL PROVIDERS (" + this.keyList.length + ")",
        value: ""
      });

      for (var prop in tempList) {
        list.push({
          text: prop + " (" + tempList[prop].length + ")",
          value: prop,
          disabled: tempList[prop].length > 0 ? false : true
        });
      }

      return list;
    },
    filterKeyList() {
      return this.keyList
        .filter(item => {
          if (this.sportType == '')
            return item.sport_type.indexOf(this.sportType) > -1;
          else
            return item.sport_type == this.sportType;
        })
        .filter(item => {
          return item.market_type.indexOf(this.marketType) > -1;
        })
        .filter(item => {
          if (this.betType == '')
            return item.bet_type.indexOf(this.betType) > -1;
          else
            return item.bet_type == this.betType;
        })
        .filter(item => {
          return item.provider.indexOf(this.providerType) > -1;
        })
        .sort((a, b) => {
          if (this.sortType == 'asc')
            return a[this.sortKey] > b[this.sortKey] ? 1 : -1;
          else
            return a[this.sortKey] < b[this.sortKey] ? 1 : -1;
        });
        // .sort((a, b) => {
        //   return a.provider > b.provider ? 1 : -1;
        // })
        // .sort((a, b) => {
        //   return a.market_type > b.market_type ? 1 : -1;
        // })
        // .sort((a, b) => {
        //   return a.sport_type > b.sport_type ? 1 : -1;
        // })
        // .sort((a, b) => {
        //   return a.bet_type > b.bet_type ? 1 : -1;
        // });
    }
  },
  created: function() {
    // this.$options.cacheList = [];
    this.$options.tempCacheList = [];
    // this.$options.cacheHash = [];
    this.$options.tempCacheHash = [];
    this.$options.refreshEnabled = false;
  },
  mounted: function() {
    this.getOMCacheKeyList();
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }

      this.getLeagueList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    showCache: function(key) {
      this.cacheTblShow = true;
      this.filterKeyBy = key;
      this.getOMCacheList();
    },
    hideCache: function() {
      this.cacheTblShow = false;
      this.filterKeyBy = "";
      this.getOMCacheKeyList();
    },
    toggleRefresh: function() {
      this.startCountDownRefresh();
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        this.getOMCacheListX(this).then(result => {}, error => console.log(error));
        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000);
      } else {
        this.refreshUpdate = "STOPPED";
      }
    },
    getOMCacheKeyList: function() {
      let url = config.getOMCacheKeyUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.omcache
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              if (typeof response.data.status == "string") {
                this.feedback.success = response.data.status == "1";
              } else {
                this.feedback.success = response.data.status == 1;
              }
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.keyOption = response.data.keys;
                this.getKeyList();
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getKeyList: function() {
      this.keyList = [];
      for (var i = 0; i < this.keyOption.length; i++) {
        var arrParent = this.keyOption[i].split(":");
        var arrChild = arrParent[1].split(".");


        if (arrChild.length >= 3)
          this.keyList.push({
            key: this.keyOption[i],
            provider: arrChild[0],
            market_type: arrChild[1],
            sport_type: arrChild[2],
            bet_type: arrChild[3],
            bot: arrChild.length > 4 ? arrChild[4] : ""
          });
        else
          continue;
      }
    },
    getOMCacheList: function() {
      this.getOMCacheListX(this).then(result => {}, error => console.log(error));
    },
    getOMCacheListX: function(e) {
      return new Promise((resolve, reject) => {
        let url = config.getOMCacheUrl();
        if (!e.filterKeyBy) {
          return reject("No Filter Key Selected");
        }
        // if (e.loading == true) {
        //   return reject("Request In Progress");
        // }
        var json = {
          action_by: e.$store.getters.username,
          session_token: e.$store.getters.sessionToken,
          page_id: config.accessRoles.omcache,
          selected_key: e.filterKeyBy
        };

        e.loading = true;
        e.$http.post(url, json).then(
          function(response) {
            e.loading = false;
            e.refreshUpdate = new Date();
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  e.feedback.success = response.data.status == "1";
                } else {
                  e.feedback.success = response.data.status == 1;
                }
                e.feedback.status = response.data.statusdesc;
                if (e.feedback.success === true) {
                  var jpayload = JSON.parse(response.data.omcache.payload);
                  e.$options.tempCacheList = jpayload.data;
                  e.tempMarketType = jpayload.market_type;
                  e.tempSportType = jpayload.sport_type;
                  e.tempBetType = jpayload.bet_type;
                  e.bot = response.data.omcache.bot;
                  e.md5 = response.data.omcache.md5;
                  e.loginId = response.data.omcache.login_id;
                  e.epochTime = response.data.omcache.epoch_time;
                  e.lastUpdate = response.data.omcache.last_update;
                  e.status = response.data.omcache.status;
                  e.tempProvider = response.data.omcache.provider;

                  e.$options.tempCacheHash = [];
                  let requests = e.$options.tempCacheList.map(item => {
                    return new Promise(resolve => {
                      var x = item;
                      x.id = SparkMD5.hash(x.ln + x.th + x.ta + x.ed + x.ot);
                      e.$options.tempCacheHash[x.id] = x;
                      // var test = e.$options.cacheHash[x.id];
                      var test = e.cacheHash[x.id];
                      if (test) {
                        Object.keys(test).forEach(k => {
                          if (!k.includes("_blink")) {
                            if (test[k] !== x[k]) {
                              x[k + "_blink"] = 1;
                            } else {
                              x[k + "_blink"] = test[k + "_blink"];
                            }
                            if (x[k + "_blink"] >= 1) {
                              x[k + "_blink"] += 1;
                            }
                            if (x[k + "_blink"] >= 15) {
                              x[k + "_blink"] = 0;
                            }
                          }
                        });
                      } else {
                        for (const k in x) {
                          if (!k.includes("_blink")) {
                            x[k + "_blink"] = 0;
                          }
                        }
                      }
                      resolve("OK");
                    });
                  });

                  Promise.all(requests).then(() => {
                    // delete e.$options.cacheList;
                    // delete e.$options.cacheHash;
                    e.displayProvider = e.tempProvider;
                    e.displayMarketType = e.tempMarketType;
                    e.displaySportType = e.tempSportType;
                    e.displayBetType = e.tempBetType;
                    // e.$options.cacheList = e.$options.tempCacheList;
                    // e.$options.cacheHash = e.$options.tempCacheHash;
                    e.cacheList = e.$options.tempCacheList;
                    e.cacheHash = e.$options.tempCacheHash;
                  });
                } else {
                  // reject(e.feedback.status);
                  if (!this.$helpers.handleFeedback(e.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + e.feedback.status), "error");
                }
              }
              resolve("OK");
            } catch (error) {
              e.loading = false;
              e.feedback.success = false;
              e.feedback.status = errorTags.request.failed;
              // reject(error);
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            e.loading = false;
            e.feedback.success = false;
            e.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            // reject(response);
          }
        );
      });
    }
  }
};
</script>


<style lang="scss" scoped>
tr,
td {
  cursor: pointer;
}
</style>

